//API
import { postRequest, putRequest, deleteRequest, getRequest } from "../globalService"

const endPoint = 'notification';

//Get All
export const getNotifications = (receiverId, body = {})=> {
    return postRequest(`${endPoint}/all/${receiverId}`,body,true);
}

//Get All Pending
export const getNotificationsPending = (receiverId, body = {})=> {
    return postRequest(`${endPoint}/pending/${receiverId}`,body,true);
}

//Get All Message Pending
export const getMessagePending = (receiverId, body = {})=> {
    return postRequest(`${endPoint}/message/pending/${receiverId}`,body,true);
}

//Read
export const readNotification = (notificationId)=> {
    return getRequest(`${endPoint}/read/${notificationId}`,true);
}
//Delete Notification
export const deleteNotification = (notificationId)=> {
    return deleteRequest(`${endPoint}/${notificationId}`,true);
}